function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy90cmFzaC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiIuLi8uLi8uLi9zcmMvaWNvbnMvdHJhc2guanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIFRyYXNoKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIzIDI2SDlWMTBoMnYxMy40MjhhMSAxIDAgMDAyIDBWMTBoMnYxMy40MjhhMSAxIDAgMDAyIDBWMTBoMnYxMy40MjhhMSAxIDAgMDAyIDBWMTBoMnYxNnpNMTQgOGg0VjZoLTR2MnptMTIgMGgtNlY2YTIgMiAwIDAwLTItMmgtNGEyIDIgMCAwMC0yIDJ2Mkg2YTEgMSAwIDAwMCAyaDF2MTZhMiAyIDAgMDAyIDJoMTRhMiAyIDAgMDAyLTJWMTBoMWExIDEgMCAxMDAtMnpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5UcmFzaC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFRyYXNoO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Trash(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M23 26H9V10h2v13.428a1 1 0 002 0V10h2v13.428a1 1 0 002 0V10h2v13.428a1 1 0 002 0V10h2v16zM14 8h4V6h-4v2zm12 0h-6V6a2 2 0 00-2-2h-4a2 2 0 00-2 2v2H6a1 1 0 000 2h1v16a2 2 0 002 2h14a2 2 0 002-2V10h1a1 1 0 100-2z",
    fill: primaryColor,
    fillRule: "evenodd"
  }));
}

Trash.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Trash;